/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type SbSharedRefineMenuMultiSelectSearch_viewer$ref = any;
export type SbSharedRefineMenuFilterStone_viewer$ref = any;
export type SbSharedRefineMenuFilterStone_viewer = {
    readonly " $fragmentRefs": SbSharedRefineMenuMultiSelectSearch_viewer$ref;
    readonly " $refType": SbSharedRefineMenuFilterStone_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbSharedRefineMenuFilterStone_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuMultiSelectSearch_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '6baebc0795a4435bd2d9eea93a8897e0';
export default node;
